module.exports = __webpack_public_path__ + "static/media/herdy-collecting-apples.135b1556.svg";